import Header from './components/header/Header.jsx'
import About from './components/about/About.jsx'
import Contact from './components/contact/Contact.jsx'
import Footer from './components/footer/Footer.jsx'
import Nav from './components/nav/Nav.jsx'
import Experience from './components/exprience/Experience.jsx'
import Project  from './components/project/Project.jsx'


import './index.css'


function App() {
  return (
    <div className="App">
      <>
      <Header></Header>
      <About></About>
      <Experience></Experience>
      <Nav></Nav>
      <Project></Project>
      <Contact></Contact>
      <Footer></Footer>

      
    
      
      
      
      
      </>
    </div>
  );
}

export default App;
